import { environment } from '@/environments/environment'
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular'
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser'

type KnownAuthority = `${string}.b2clogin.com`

export function loggerCallback(level: LogLevel, message: string, containsPii: boolean): void {
  if (containsPii) return
  if (!environment.production) console.debug(`[MSAL] ${LogLevel[level]}: ${message}`)
}

export function MSALInstanceFactory(): IPublicClientApplication {
  const { clientId, authority } = environment.msalConfig.auth

  const authorityUrl = new URL(authority)
  const authorityHost = authorityUrl.host

  return new PublicClientApplication({
    auth: {
      clientId,
      authority,
      knownAuthorities: [authorityHost],
      redirectUri: '/auth',
      postLogoutRedirectUri: '/logout',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
    system: {
      allowPlatformBroker: false,
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Error,
        piiLoggingEnabled: false,
      },
    },
  })
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const map = new Map<string, string[]>()
  map.set(environment.apiConfig.profile.uri, environment.apiConfig.profile.scopes)

  // ProSync partage l'app/scope B2C de ProFile : on attache le même token aux appels ProSync.
  const syncUri = environment.apiConfig.sync?.uri
  if (syncUri) {
    map.set(syncUri, environment.apiConfig.profile.scopes)
  }

  // ProID : scope DÉDIÉ (l'API valide proid.user_impersonation) — token distinct par ressource.
  const proid = environment.apiConfig.proid
  if (proid?.uri) {
    map.set(proid.uri, proid.scopes)
  }

  return { interactionType: InteractionType.Redirect, protectedResourceMap: map }
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: { scopes: [...environment.apiConfig.profile.scopes] },
    loginFailedRoute: '/login-failed',
  }
}

